import { createSlice } from '@reduxjs/toolkit';
import {
  getListUserAction,
  postUsersAction,
  resetPassWordUsersAction,
  statusUsersAction,
  updateUsersAction,
} from './users.action';

const initialState: Users.UsersState = {
  isLoading: false,
  error: null,
  listUsers: {
    items: [],
    limit: 10,
    page: 1,
    totalCount: 0,
    totalPage: 0,
  },
};

const { actions, reducer } = createSlice({
  name: 'users_slice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getListUserAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getListUserAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.listUsers = {
          items: action.payload.records,
          limit: action.payload.pageSize,
          page: action.payload.page,
          totalCount: action.payload.totalRecords,
          totalPage: action.payload.totalPage,
        };
      })
      .addCase(getListUserAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(postUsersAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(postUsersAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(postUsersAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      .addCase(updateUsersAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(updateUsersAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateUsersAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      .addCase(resetPassWordUsersAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(resetPassWordUsersAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(resetPassWordUsersAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      .addCase(statusUsersAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(statusUsersAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(statusUsersAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      });
  },
});

export { reducer };
export default actions;
